import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentCustomService } from 'app/environment/environment-custom/services/environment-custom.service';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';
import { SequenceService } from './services/sequences.service';
import { ResetConfirmationComponent } from 'app/shared/components/reset-confirmation/reset-confirmation.component';

@Component({
  selector: 'biz-sequences',
  templateUrl: './sequences.component.html',
  styleUrls: ['./sequences.component.scss']
})
export class SequencesComponent implements OnInit {
  public customMetadataArray: ICustomMetadata[] = [];
  public sequences: ISequence[] = [];
  public language: string;
  public screenHeight: number;
  public pageLength: number;
  public isOpenModalReset: boolean = false;
  public isSaving = false;

  private dataTableRef: any;
  private columns: any = [
    {
      title: this._i18nService.instant('SEQUENCE.COLUMN_NAME'),
      data: 'DisplayName',
      className: 'bs-data-table-sequences__cell',
      render: (data: any, type: any) => {
        if (type === 'display') {
          return `<p>${data}</p>`;
        }
        return data;
      }
    },
    {
      title: this._i18nService.instant('SEQUENCE.COLUMN_SEED'),
      data: 'Seed',
      className: 'bs-data-table-sequences__cell',
      render: (data: any, type: any) => {
        if (type === 'display') {
          return `<p>${data}</p>`;
        }
        return data;
      }
    },
    {
      title: this._i18nService.instant('SEQUENCE.COLUMN_INCREMENT'),
      data: 'Increment',
      className: 'bs-data-table-sequences__cell',
      render: (data: any, type: any) => {
        if (type === 'display') {
          return `<p>${data}</p>`;
        }
        return data;
      }
    },
    {
      title: this._i18nService.instant('SEQUENCE.COLUMN_CURRENT_VALUE'),
      data: 'CustomValue',
      className: 'bs-data-table-sequences__value',
      render: (data: any, type: any, row: any) => {
        if (type === 'display') {
          const valueToDisplay = row.IdSequenceValue !== 0 ? data : row.Seed;
          const hasError = this.checkError(row) && row.IdSequenceValue !== 0;
          const message = this._i18nService.instant('SEQUENCE.MESSAGE_ERROR');
          const customId = `error${row.Id}`;
          const inputId = `input${row.Id}`;

          let elementosPadre = document.querySelectorAll('.bs-data-table-sequences__value');
          elementosPadre.forEach(function (elementoPadre) {
            if (elementoPadre.querySelector('.bs-data-table-sequences__input-showError')) {
              if (elementoPadre instanceof HTMLElement) {

                elementoPadre.style.padding = '8px !important';
              }
            }
          });

          return `
            <div class="bs-data-table-sequences__input">
              <input id="${inputId}" type="number" value="${valueToDisplay}" [(ngModel)]="row.CustomValue" (ngModelChange)="checkError(row)">
              <div id="${customId}" class="${hasError ? 'bs-data-table-sequences__input-showError' : 'bs-data-table-sequences__input-hideError'}">${message}</div>
            </div>`;
        }
        return data;
      }
    },
    {
      title: '',
      className: 'bs-data-table-sequences__options',
      data: null,
      orderable: false,
      render: (data: any, type: any, row: any) => {
        if (type === 'display') {
          const btnSaveId = `btnSave${row.Id}`;
          const btnResetId = `btnReset${row.Id}`;
          const messageSave = this._i18nService.instant('GLOBAL.SAVE');
          const messageReset = this._i18nService.instant('GLOBAL.RESET');
          return `<div class="bs-data-table-sequences__options-buttons">
                    <button id="${btnSaveId}" class="bs-data-table-sequences__options-buttons__save" disabled>${messageSave}</button>
                    <button id="${btnResetId}"  class="bs-data-table-sequences__options-buttons__reset">${messageReset}</button>
                  </div>`;
        }
        return data;
      }
    }
  ];
  // ===== table =======
  @ViewChild('dataTable') dataTable: ElementRef;
  saveButtons: any = [];

  constructor(
    public envCustomService: EnvironmentCustomService,
    public sequenceService: SequenceService,
    private _i18nService: I18nService,
    private renderer: Renderer2,
    private _modalService: BzgModalService,
    private _toastService: BzgToastService,
    private _translateService: TranslateService) {
  }

  ngOnInit() {
    this.language = this._translateService.getBrowserLang();
    this.screenHeight = window.innerHeight;
    this.getSequences();
    this.setElements();
  };

  getSequences() {
    this.sequenceService.getSequences().subscribe((sequences: any) => {
      if (sequences.Successful)
        this.sequences = sequences.SequencesList;
      this.initDataTable();
    });
  }

  updateSequence(sequence: any, rowIndex) {
    this.sequenceService.updateSequence(sequence).subscribe((sequences: any) => {
      this.isSaving = false;
      this.btnSaveResetEnable(rowIndex, false, 'Save');
      this.btnSaveResetEnable(rowIndex, false, 'Reset');
      this.sequences.find(seq => seq.Id === sequences.SequencesList[0].Id).IdSequenceValue = sequences.SequencesList[0].IdSequenceValue;

      const inputId = `input${sequences.SequencesList[0].Id}`;
      const input = document.getElementById(inputId);
      input.style.border = `#e0e0e0 solid 1px`;

      if (sequences.Successful)
        this.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
      else
        this.showToast(this._i18nService.instant('GLOBAL.AN_ERROR_HAS_OCCURRED'), 'error');
    });
  }

  setElements() {
    this.pageLength = 3;
    if (this.screenHeight >= 600 && this.screenHeight < 700)
      this.pageLength = 5;
    if (this.screenHeight >= 700 && this.screenHeight < 780)
      this.pageLength = 6;
    if (this.screenHeight >= 780 && this.screenHeight < 900)
      this.pageLength = 7;
    if (this.screenHeight >= 900)
      this.pageLength = 8;
  }

  initDataTable() {
    if ($.fn.DataTable.isDataTable(this.dataTable.nativeElement)) {
      $(this.dataTable.nativeElement).DataTable().clear().destroy();
    }

    this.dataTableRef = $(this.dataTable.nativeElement).DataTable({
      data: this.sequences,
      columns: this.columns,
      language: {
        searchPlaceholder: this._i18nService.instant('ENVIRONMENT.SEARCH'),
        zeroRecords: this._i18nService.instant('ENVIRONMENT.NO_DATA'),
        info: this._i18nService.instant('ENVIRONMENT.PAGINATOR_INFO'),
        infoEmpty: this._i18nService.instant('ENVIRONMENT.NO_DATA'),
        infoFiltered: '',
        emptyTable: this._i18nService.instant('ENVIRONMENT.NO_DATA'),
        paginate: {
          first: this._i18nService.instant('ENVIRONMENT.FIRST'),
          last: this._i18nService.instant('ENVIRONMENT.LAST'),
          next: this._i18nService.instant('ENVIRONMENT.NEXT'),
          previous: this._i18nService.instant('ENVIRONMENT.PREVIOUS')
        }
      },
      pageLength: this.pageLength,

      drawCallback: () => {
        this.tableActions();
      },
      rowCallback: (row, data: any) => {
        $(row).find('td:eq(0)').attr('title', data.DisplayName);
        $(row).find('td:eq(1)').attr('title', data.Seed);
        $(row).find('td:eq(2)').attr('title', data.Increment);
        $(row).find('td:eq(3)').attr('title', data.CurrentValue);
      }
    });
  }

  tableActions() {
    const valueInputs = this.dataTable.nativeElement.querySelectorAll('input');
    valueInputs.forEach(cell => {
      this.renderer.listen(cell, 'keyup', ($event) => {
        const keyCode = $event.code;
        // Validar si la tecla presionada es un número, delete o retroceso
        if ((keyCode >= 'Digit0' && keyCode <= 'Digit9') ||
          (keyCode >= 'Numpad0' && keyCode <= 'Numpad9') ||
          keyCode === 'Backspace' || keyCode === 'Delete' ||
          keyCode === 'KeyV') {
          this.getInfoSequence(cell, false);
        }
        else if (keyCode === 'NumpadSubtract' || keyCode === 'NumpadAdd' || keyCode === 'NumpadDecimal'
          || keyCode === 'Period' || keyCode === 'Slash' || keyCode === 'BracketRight') {
          const rowIndex = cell.closest('tr')._DT_RowIndex;
          $event.target.value = this.sequences[rowIndex].CustomValue.toString();
          this.btnSaveResetEnable(rowIndex, true, 'Save');
        }
      });
      const rowIndex = cell.closest('tr')._DT_RowIndex;
      const inputId = `input${this.sequences[rowIndex].Id}`;
      const input = document.getElementById(inputId);
      this.addEventFocusAndBlur(input);
    });

    const valueBtn = this.dataTable.nativeElement.querySelectorAll('.bs-data-table-sequences__options-buttons__save');
    valueBtn.forEach(cell => {
      if (!this.saveButtons.includes(cell.id)) {
        this.saveButtons.push(cell.id);
        this.renderer.listen(cell, 'click', ($event) => {
          this.getInfoSequence(cell, true);
        });
      }
    });

    const buttonReset = this.dataTable.nativeElement.querySelectorAll('.bs-data-table-sequences__options-buttons__reset');
    buttonReset.forEach(cell => {
      this.renderer.listen(cell, 'click', ($event) => {
        const rowIndex = cell.closest('tr')._DT_RowIndex;
        const displayName = cell.closest('tr').querySelector('td:first-child').textContent;
        this.resetSequence(rowIndex, displayName);
      });
    });
  }

  addEventFocusAndBlur(input: any) {
    input?.addEventListener('focus', function () {
      input.style.border = `#217d7e solid 1px`;
    });
    input?.addEventListener('blur', function () {
      input.style.border = `#e0e0e0 solid 1px`;
    });
  }

  btnSaveResetEnable(rowIndex, enable, btn) {
    const customId = `btn${btn}${this.sequences[rowIndex].Id}`;
    let boton = document.getElementById(customId) as HTMLInputElement;
    boton.disabled = enable;
  }

  getInfoSequence(cell, updateService) {

    const rowIndex = cell.closest('tr')._DT_RowIndex;
    this.btnSaveResetEnable(rowIndex, true, 'Save');

    let customValue = cell.closest('tr').querySelector('td:nth-child(4) input').value;
    customValue = Number(customValue) > 999999999 ? 999999999 : customValue;

    this.sequences[rowIndex].CustomValue = Number(customValue);
    this.showError(rowIndex);


    this.setValueInput(rowIndex);
    if (updateService) {
      this.isSaving = true;
      this.btnSaveResetEnable(rowIndex, true, 'Save');
      this.btnSaveResetEnable(rowIndex, true, 'Reset');
      this.updateSequence(this.sequences[rowIndex], rowIndex);
    }
  }

  showError(rowIndex) {
    const customId = `error${this.sequences[rowIndex].Id}`;

    if (this.checkError(this.sequences[rowIndex])) {
      this.btnSaveResetEnable(rowIndex, true, 'Save');
      document.getElementById(customId).classList.remove("bs-data-table-sequences__input-hideError");
      document.getElementById(customId).classList.add("bs-data-table-sequences__input-showError");

      this.setColorBorder(rowIndex, '#da3b3b', true);
      this.setHeight('63px', '.bs-data-table-sequences__input-showError');

    } else {
      this.btnSaveResetEnable(rowIndex, false, 'Save');
      document.getElementById(customId).classList.remove("bs-data-table-sequences__input-showError");
      document.getElementById(customId).classList.add("bs-data-table-sequences__input-hideError");
      this.setColorBorder(rowIndex, '#217d7e', false);
      this.setHeight('42px', '.bs-data-table-sequences__input-hideError');
    }
  }

  setColorBorder(rowIndex: number, color: string, isError: boolean) {
    const inputId = `input${this.sequences[rowIndex].Id}`;
    let input = document.getElementById(inputId);
    if (input instanceof HTMLInputElement) {
      input.style.border = `1px solid ${color}`;
      if (isError) {
        const parent: any = input.parentNode;
        parent.style.paddingTop = '6px';
      }
    }
  }

  setHeight(height, className) {
    let elementosPadre = document.querySelectorAll('.bs-data-table-sequences__value');
    elementosPadre.forEach(function (elementoPadre) {
      if (elementoPadre.querySelector(className)) {
        if (elementoPadre instanceof HTMLElement) {
          elementoPadre.style.height = height;
        }
      }
    });
  }

  checkError(row: any) {
    return row.CustomValue < row.Seed;
  }

  setValueInput(rowIndex) {
    const inputId = `input${this.sequences[rowIndex].Id}`;
    let input = document.getElementById(inputId) as HTMLInputElement;
    input.value = this.sequences[rowIndex].CustomValue.toString();
  }

  resetSequence(rowIndex: number, displayName: string) {
    if (!this.isOpenModalReset) {
      this.isOpenModalReset = true;
      const title = this._i18nService.instant('SEQUENCE.RESET_CURRENT_VALUE');
      const message = this._i18nService.instant('SEQUENCE.RESET_CURRENT_VALUE_MESSAGE').replace('{{0}}', displayName);
      const modal = this._modalService.open(ResetConfirmationComponent, {
        closeOnBackdropClick: false,
        closeOnRouterNavigation: true,
        data: { title, message, button: 'SEQUENCE.RESET_CURRENT_VALUE' }
      });
      modal.afterClosed().subscribe((result) => {
        this.isOpenModalReset = false;
        if (result === 'reset') {
          this.sequences[rowIndex].CustomValue = this.sequences[rowIndex].Seed;

          this.setValueInput(rowIndex);

          this.showError(rowIndex);
          this.updateSequence(this.sequences[rowIndex], rowIndex);
        }
      });
    }
  }

  showToast(messageInput: string, type: BzgToastType) {
    this._toastService.open(
      messageInput,
      {
        type,
        duration: 1000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right'
      });
  }

  get getSequenceSubtitle() {
    return this._i18nService.instant('SEQUENCE.SEQUENCES_SUBTITLE');
  }

}
